import { render, staticRenderFns } from "./cascader.vue?vue&type=template&id=5df84adc&scoped=true&"
import script from "./cascader.vue?vue&type=script&lang=js&"
export * from "./cascader.vue?vue&type=script&lang=js&"
import style0 from "./cascader.vue?vue&type=style&index=0&id=5df84adc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df84adc",
  null
  
)

export default component.exports